import { IMDMUnitInstance } from '@/pages/MDM/mdm.types.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import css from '../unitInstanceSidePage.module.css'
import timeUtils from '@/utils/time.utils.ts'
import FormEditButton from '@/shared/Buttons/FormEditButton'
import FormDeleteButton from '@/shared/Buttons/FormDeleteButton'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'
import useUnit from '@/pages/MDM/hooks/useUnit.ts'
import UnitInstanceValue from 'src/pages/MDM/components/Units/UnitInstanceValue'

interface IProps {
  instance: IMDMUnitInstance
  onEdit: () => void
  onClose: () => void
}

const ViewUnitInstanceSidePageContent = (props: IProps) => {
  const unit = useUnit(props.instance.unitId)

  const handleDeleteInstance = () => {
    confirmService.requestConfirm({
      description: `Подтвердите удаление инстанса ${props.instance.name}`,
      buttonType: 'primary',
      onConfirm: () =>
        mdmApi
          .deleteUnitInstance(props.instance.id)
          .then((r) => r.status === 'success' && mdmEvents.unitInstanceDeleted(r.body.id)),
    })
  }

  const renderValues = () => {
    return unit.fields.map((f, index) => (
      <div key={f.id} className={css.sidePageGrid}>
        <p className="text-nm text-secondary">{f.name}:</p>
        <UnitInstanceValue value={props.instance.values[index]} field={f} />
      </div>
    ))
  }

  return (
    <div className="flex-lines gap16 height100">
      <h4 className="text-heading-4">{props.instance.name}</h4>
      <SeparateLine />
      <div className={css.sidePageGrid}>
        <p className="text-nm text-secondary">Дата создания:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(props.instance.createdAt), 'dd MMM yyyy, HH:mm')}</p>
        <p className="text-nm text-secondary">Дата обновления:</p>
        <p className="text-nm">{timeUtils.formatDate(new Date(props.instance.updatedAt), 'dd MMM yyyy, HH:mm')}</p>
      </div>
      <SeparateLine />
      <h5 className="text-heading-4">Значения</h5>
      {renderValues()}
      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8" style={{ paddingBottom: '24px' }}>
        <FormEditButton onClick={props.onEdit} />
        <FormDeleteButton onClick={handleDeleteInstance} />
      </div>
    </div>
  )
}

export default ViewUnitInstanceSidePageContent
